import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9d520f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex some-inputs m-b-8" }
const _hoisted_4 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название воркбука", -1))
const _hoisted_6 = { class: "flex flex-col input-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Организация", -1))
const _hoisted_8 = { class: "toggle-row m-t-10 m-b-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Добавлять в демо-аккаунты при их создании", -1))
const _hoisted_10 = { class: "flex flex-col fl-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Токен воркбука", -1))
const _hoisted_12 = { class: "flex some-inputs m-b-8" }
const _hoisted_13 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название дашборда", -1))
const _hoisted_15 = { class: "flex fl-jc-sb fl-1 flex-end" }
const _hoisted_16 = { class: "flex flex-col fl-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Datalens ID", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "flex flex-col fl-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Описание", -1))
const _hoisted_26 = { class: "flex flex-center m-t-18" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Роли, которым доступно редактирование (если не указаны, то доступно всем):", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "flex flex-center" }
const _hoisted_32 = { class: "flex some-inputs m-t-4 fl-1" }
const _hoisted_33 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Департамент", -1))
const _hoisted_35 = { class: "flex input-container flex-end" }
const _hoisted_36 = { class: "flex flex-col fl-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Роль", -1))
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]

import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDashbordsStore } from "@/store/analytics/dasboards";
import { useOrganizationsStore } from "@/store/dictionaries/organizations";
import { useOrganizationsDictionaryStore } from "@/store/catalog_data/organizations";

import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";

import { areWorkbookFieldsValid } from "@/services/dictionaries/workbooks";
import { rootGetters } from "@/main";
import { insertNewLines } from "@/services/utils/Strings";
import { Department } from "@/store/dictionaries/organizations";
import { Role } from "@/store/analytics/dasboards";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkbookCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useDashbordsStore();
const orgStore = useOrganizationsDictionaryStore();
const organizationsStore = useOrganizationsStore();

const workbook = ref({
  client_workbook: {
    name: "",
    token: "",
    tenant: "",
    organization_id: null as null | number,
    include_to_demo_accounts: false,
  },
  dashboards: [
    {
      name: "",
      description: "",
      datalens_id: "",
      roles: [] as Role[],
    },
  ],
});

const isLoadingData = ref(false);
const isInvalidForm = ref(false);
const isWorkbookSetted = computed(() => {
  return Boolean(route.params.id);
});
const departments = ref([] as Department[]);
const isDemoOrganization = ref(false);

const loadOrganizationsWithDemo = () => {
  organizationsStore
    .getOrganizations({ page: 1, per_page: 100, include_demo: true, order_by: "name" })
    .then(() => {
      orgStore.itemList = organizationsStore.organizationsList as any;
    });
};

watch(
  () => workbook.value.client_workbook.organization_id,
  () => {
    if (workbook.value.client_workbook.organization_id)
      organizationsStore
        .getOrganizationBase(workbook.value.client_workbook.organization_id)
        .then((data) => {
          if (data) {
            departments.value = data.departments;
            return;
          }
        });
  },
);

const reload = () => {
  if (isWorkbookSetted.value) {
    isLoadingData.value = true;
    const workbookId = parseInt(route.params.id);
    store
      .getWorkbook(workbookId)
      .then((workbookClone) => {
        if (workbookClone) {
          isDemoOrganization.value = Boolean((workbookClone as any).is_demo);
          if (isDemoOrganization.value) {
            loadOrganizationsWithDemo();
          }

          workbook.value.client_workbook.name = workbookClone.name;
          workbook.value.client_workbook.tenant = workbookClone.tenant;
          workbook.value.client_workbook.token = "************";
          workbook.value.client_workbook.organization_id =
            workbookClone.organization_id;
          workbook.value.client_workbook.include_to_demo_accounts =
            workbookClone.include_to_demo_accounts || false;
          workbook.value.dashboards = workbookClone.dashboards;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const getRoles = (depId: number) => {
  const dep = departments.value.find((item) => item.id == depId);
  if (dep && dep.roles) return dep.roles;
  return [];
};

const addDashboard = (idx: number) => {
  workbook.value.dashboards.splice(idx + 1, 0, {
    name: "",
    description: "",
    datalens_id: "",
    roles: [],
  });
};

const deleteDashboard = (idx: number) => {
  workbook.value.dashboards.splice(idx, 1);
};

const createWorkbook = () => {
  if (!areWorkbookFieldsValid(workbook.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`,
    );
    return;
  }

  const workbookCopy = { ...workbook.value };

  let token = insertNewLines(
    workbook.value.client_workbook.token,
    "-----BEGIN RSA PRIVATE KEY-----",
  );
  token = insertNewLines(token, "-----END RSA PRIVATE KEY-----");
  workbookCopy.client_workbook.token = token;

  const org = orgStore.itemList.find(
    (e) => e.id == workbook.value.client_workbook.organization_id,
  );
  if (org) {
    workbookCopy.client_workbook.tenant = org.tenant;
  } else if (isWorkbookSetted.value && isDemoOrganization.value) {
    workbookCopy.client_workbook.tenant = workbook.value.client_workbook.tenant;
  } else {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Тенант организации не найден.`,
    );
    return;
  }

  workbookCopy.dashboards.forEach((el) => {
    const uniqueRoleIds = Array.from(new Set(el.roles.map((role) => role.id)));
    el["roles_ids"] = uniqueRoleIds;
  });

  if (workbook.value.client_workbook.token == "************") {
    delete (workbookCopy.client_workbook as any).token;
  }

  emit("setLoading", true);
  if (!isWorkbookSetted.value) {
    performOrganizationAction(() => store.createWorkbook(workbookCopy));
  } else {
    performOrganizationAction(() =>
      store.updateWorkbook(workbookCopy, parseInt(route.params.id)),
    );
  }
};

const performOrganizationAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "workbooks" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleCampaignSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

const addRole = (idxRole: number, idxDashboard: number) => {
  workbook.value.dashboards[idxDashboard].roles.splice(idxRole + 1, 0, {
    id: 0,
    department: { id: 0 },
  });
};

const deleteRole = (idxRole: number, idxDashboard: number) => {
  workbook.value.dashboards[idxDashboard].roles.splice(idxRole, 1);
};

__expose({
  createWorkbook,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                id: "slug",
                placeholder: "Введите значение",
                modelValue: workbook.value.client_workbook.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((workbook.value.client_workbook.name) = $event)),
                invalid: isInvalidForm.value && workbook.value.client_workbook.name == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CatalogDataSingleInput, {
                useIdOnly: true,
                selectType: "organization",
                "is-invalid": 
                isInvalidForm.value &&
                workbook.value.client_workbook.organization_id == null
              ,
                isSegmentSetted: false,
                modelValue: workbook.value.client_workbook.organization_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                ($event) => (workbook.value.client_workbook.organization_id = $event)
              )
              }, null, 8, ["is-invalid", "modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_unref(InputSwitch), {
          modelValue: workbook.value.client_workbook.include_to_demo_accounts,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((workbook.value.client_workbook.include_to_demo_accounts) = $event)),
          inputId: "include_to_demo_accounts"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(Textarea), {
              autoResize: "",
              invalid: isInvalidForm.value && workbook.value.client_workbook.token == '',
              modelValue: workbook.value.client_workbook.token,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((workbook.value.client_workbook.token) = $event)),
              rows: "5",
              cols: "30"
            }, null, 8, ["invalid", "modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workbook.value.dashboards, (dashboard, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "form-block",
        key: `dash-${idx}`
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputText), {
                  id: "slug",
                  placeholder: "Введите значение",
                  modelValue: dashboard.name,
                  "onUpdate:modelValue": ($event: any) => ((dashboard.name) = $event),
                  invalid: isInvalidForm.value && dashboard.name == ''
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
                default: _withCtx(() => [
                  _createVNode(_unref(InputText), {
                    id: "slug",
                    placeholder: "Введите значение",
                    modelValue: dashboard.datalens_id,
                    "onUpdate:modelValue": ($event: any) => ((dashboard.datalens_id) = $event),
                    invalid: isInvalidForm.value && dashboard.datalens_id == ''
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
                ]),
                _: 2
              }, 1032, ["is-loading"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["group-button-container flex", [idx != workbook.value.dashboards.length - 1 ? 'hidden' : '']])
            }, [
              (workbook.value.dashboards.length > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete-button flex flex-center m-l-12",
                    onClick: ($event: any) => (deleteDashboard(idx))
                  }, _hoisted_20, 8, _hoisted_18))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "add-button flex flex-center",
                onClick: ($event: any) => (addDashboard(idx))
              }, _hoisted_23, 8, _hoisted_21)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(Textarea), {
                autoResize: "",
                modelValue: dashboard.description,
                "onUpdate:modelValue": ($event: any) => ((dashboard.description) = $event),
                rows: "5",
                cols: "30"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          (dashboard.roles.length == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "add-button flex flex-center",
                onClick: ($event: any) => (addRole(-1, idx))
              }, _hoisted_30, 8, _hoisted_28))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboard.roles, (role, idxr) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex flex-col fl-1 m-b-8 role-container",
            key: `role-${idxr}`
          }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_unref(Dropdown), {
                    modelValue: role.department.id,
                    "onUpdate:modelValue": ($event: any) => ((role.department.id) = $event),
                    invalid: isInvalidForm.value && role.department.id == null,
                    optionLabel: "name",
                    options: departments.value,
                    optionValue: "id",
                    placeholder: "Выберите значение",
                    filter: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid", "options"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_unref(Dropdown), {
                      modelValue: role.id,
                      "onUpdate:modelValue": ($event: any) => ((role.id) = $event),
                      invalid: isInvalidForm.value && role.department.id == null,
                      optionLabel: "name",
                      options: getRoles(role.department.id),
                      optionValue: "id",
                      disabled: role.department.id == 0,
                      placeholder: "Выберите значение",
                      filter: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid", "options", "disabled"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["group-button-container role flex", [idxr != dashboard.roles.length - 1 ? 'hidden' : '']])
                  }, [
                    _createElementVNode("div", {
                      class: "delete-button flex flex-center m-l-8",
                      onClick: ($event: any) => (deleteRole(idxr, idx))
                    }, _hoisted_40, 8, _hoisted_38),
                    _createElementVNode("div", {
                      class: "add-button flex flex-center",
                      onClick: ($event: any) => (addRole(idxr, idx))
                    }, _hoisted_43, 8, _hoisted_41)
                  ], 2)
                ])
              ])
            ])
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})